import { FormContent, FormValidationSnackbar, Message, MessageType } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../translations';

import { NfzDepartmentFormController } from './NfzDepartmentForm.types';
import { NfzDepartmentSelect } from './NfzDepartmentSelect';

type NfzDepartmentFormProps = Pick<NfzDepartmentFormController, 'register' | 'formState'>;

export const NfzDepartmentForm = (props: NfzDepartmentFormProps): JSX.Element => {
   const { register, formState } = props;

   return (
      <>
         <FormContent testId={'nfzDepartment'}>
            <Message
               type={MessageType.WARNING}
               fullWidth
               displayIndicator
               label={draftPrescriptionsTranslationKeys.missingNfzDepartment}
               testId={'status'}
            />
            <NfzDepartmentSelect
               controller={register('nfzDepartment', { required: true })}
               label={draftPrescriptionsTranslationKeys.nfzDepartment}
            />
         </FormContent>
         <FormValidationSnackbar formState={formState} />
      </>
   );
};
